import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnnouncekitModule } from 'announcekit-angular'

import { DataListCnpjs, ListCnpjsResponseModel } from '../../../../models/responses/list-cnpjs-response.model';

import { UserService } from '../../../../services/common/user.service';
import { NotificationBellComponent } from '../notification-bell/notification-bell.component';

import { FormatCnpjPipe } from "../../../../pipes/format-cnpj.pipe";

import { environment } from '../../../../../../environments/environment';
import { UserStore } from '../../models/internal/user.store';

@Component({
  selector: 'app-user',
  imports: [CommonModule, ReactiveFormsModule, FormatCnpjPipe, AnnouncekitModule, NotificationBellComponent],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent implements OnInit {

  _isCnpjSelected: boolean = false;
  _selectedCnpj: string = '';

  isVisibleListCnpjs: boolean = false;

  listCnpjsResponse: ListCnpjsResponseModel = {} as ListCnpjsResponseModel;
  filteredCnpjs: DataListCnpjs[] = [];

  announcekitWidget: string = environment.ANNOUNCEKIT_WIDGET;

  constructor(
    public userService: UserService,
    public auth: AuthService,
    public userStore: UserStore
  ) { }

  ngOnInit(): void {
    this.userService.fetchUserPicture();
    this.userService.loadCNPJFromStorage();
    this.userService.getCnpj();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          this.updateElementStyle();
        }
      });
    });

    // Configuração do observer para observar o body por mudanças no DOM
    observer.observe(document.body, { childList: true, subtree: true });
    this.auth.user$.subscribe((user) => {
      if (!user) return
      this.userStore.setEmail(user.email!);
    }
    );
  }

  logout(): void {
    this.userService.logout();
  }

  updateElementStyle(): void {
    const element = document.querySelector('div[data-announcekit-mode="badge"]');
    if (element && element instanceof HTMLElement) {
      element.style.display = 'flex';
      element.style.alignItems = 'center';
      element.style.justifyContent = 'center';
      element.style.position = 'relative';

      const badge = element.querySelector('a.announcekit-widget-badge');
      if (badge && badge instanceof HTMLElement) {
        badge.style.position = 'absolute';
        badge.style.top = '10';
        badge.style.right = '0';
      }
    }
  }
}
